// perloader Form js
$(window).on('load', function () {
  $('.preload-main').delay(1000).fadeOut(800)
})
